/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Gov_ConnectorsInputs */



/**
* | output |
* | --- |
* | "External connectors" |
*
* @param {Compare_Gov_ConnectorsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_gov_connectors = /** @type {((inputs?: Compare_Gov_ConnectorsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Gov_ConnectorsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Externe Konnektoren")
	return /** @type {LocalizedString} */ ("External connectors")
});